import { useTranslation, Trans } from "react-i18next";
import formatCurrency from "utils/formatCurrency";
import styles from "./styles.module.scss";
import Instruction from "components/base/Instruction";
import { useAppContext } from "context/AppContext";
import { renderLogo } from "utils/renderLogo";
import useGetSelectedPaymentMethodData from "hooks/utils/useGetSelectedPaymentMethodData";
import useUser from "hooks/useUser";
import TableOrder from "components/base/TableOrder";
import { TableOrderContentType } from "types/components/TableOrder";
import { PropagateLoader } from "react-spinners";
import useGetData from "hooks/api/useGetData";

interface DrawerOrderProps {
  content: TableOrderContentType;
  isLoading?: boolean;
  isFinalStatus?: boolean;
  initiatePayment?:boolean;
}

const DrawerOrder = ({ content, initiatePayment  }: DrawerOrderProps) => {
  const { t, i18n } = useTranslation();
  const appContext = useAppContext();
  const { data: paymentMethodData } = useGetSelectedPaymentMethodData();
  const { themes } = useGetData();
  const { user } = useUser();
  const finalQuote = user?.quote;

  const instruction1 = t("yourOrder.instruction1");
  const confirmText = t("yourOrder.confirm");
  const instruction2 = (
    <Trans
      i18nKey="yourOrder.instruction2"
      values={{ brand: t("yourOrder.instruction3") }}
      components={{ 1: <span className={styles.Maviance} /> }}
    />
  );
  const instruction3 = t("yourOrder.instruction3");

  const footerRows = [
    {
      title: t("yourOrder.subTotal"),
      value: formatCurrency(Number(appContext.amount) || 0)
    },  
    {
      title: t("yourOrder.fees"),
      value: formatCurrency(finalQuote),
      highlight: true
    },
    {
      title: t("yourOrder.priceTotal"),
      value: formatCurrency(Number(appContext?.amount) + (finalQuote || 0) || 0)
    }
  ];

  return (
    <>
      <TableOrder 
        content={content} 
        footerRows={footerRows} 
      />
      {initiatePayment && (
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "1rem",
            gap: "20px"
          }}
        >
          <PropagateLoader data-testid="loading-screen-loader" size={10} color={themes.primaryColor} />
          <div className={styles.waitText} data-testid="loading-screen-title">
            {t("secondScreen.pleaseWait")}
            {"..."}
          </div>
        </div>
      )}
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Instruction
          imgUrl={renderLogo(appContext?.paymentMethod)}
          containerClassName={styles.inlineContainer}
          htmlContent={paymentMethodData?.instructions?.find((l) => l.lang === i18n.language)?.text}
        >
          <div className={styles.instructionText} data-testid="loading-screen-title">
            <span className={styles.waitText}> {instruction1}&nbsp;</span>
            <span className={styles.confirm}> {confirmText},&nbsp; </span>
            <span className={styles.waitText}>{instruction2}&nbsp;</span>
            {i18n.language === "en" && (
              <span className={styles.Maviance}> {instruction3}</span>
            )}
          </div>
        </Instruction>
        
      </div>
    </>
  );
};


export default DrawerOrder;
